import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, LOGO_WHITE } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem("akdp-token", data.token);
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-white/10 bg-charcoal/40 p-8" data-testid="admin-login-form">
        <img src={LOGO_WHITE} alt="ARTILLERY KDP" className="h-8 w-auto mb-2" draggable={false} />
        <p className="text-[10px] tracking-[0.3em] text-smoke mb-8">ADMIN ACCESS</p>
        <label className="block text-[10px] font-bold tracking-[0.25em] text-smoke mb-2" htmlFor="a-email">EMAIL</label>
        <input id="a-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email"
          className="w-full h-12 bg-ink border border-white/15 px-4 text-sm outline-none focus:border-pink mb-5" />
        <label className="block text-[10px] font-bold tracking-[0.25em] text-smoke mb-2" htmlFor="a-pass">PASSWORD</label>
        <input id="a-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password"
          className="w-full h-12 bg-ink border border-white/15 px-4 text-sm outline-none focus:border-pink" />
        {error && <p className="mt-4 text-xs text-pink" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="mt-6 w-full h-12 bg-bone text-ink text-sm font-extrabold tracking-[0.2em] hover:bg-pink hover:text-white transition-colors duration-200 disabled:opacity-50">
          {loading ? "SIGNING IN…" : "SIGN IN"}
        </button>
      </form>
    </div>
  );
}
